import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ProductsSummaryListItem from './ProductsSummaryListItem';
import { convertPrice } from "../utils";

const styles = theme => ({
  container: {
    '&& [role=listitem]': {
      width: '100%',
    },
    padding: '23px 0',
    backgroundColor: 'rgba(237,237,237,0.5)'
  },
  item: {
    padding: '8px 0',
    fontSize: 13,
  },
  consentSolution: {
    '&& .label > p': {
      color: '#00A1A1',
      fontSize: 14,
      fontWeight: 400,
    },
    borderBottom: '1px solid #EDEDED;'
  },
  depth: {
    '&& .label': {
      paddingLeft: 10,
    }
  },
  frequency: {
    '&& .label': {
      paddingLeft: 20,
    }
  },
  domain: {
    '&& .label': {
      paddingLeft: 30,
    }
  },
  footer: {
    marginTop: 10,
    '&& p': {
      color: '#212322',
      fontSize: 13,
      fontWeight: 500,
    }
  },
  header: {
    marginTop: 10,
    paddingBottom: 10,
    '&& p': {
      color: '#212322',
      fontSize: 13,
      fontWeight: 500,
    },
    borderBottom: '1px solid #EDEDED;'
  }
});

class ProductsSummary extends React.Component {
  state = {
    opened: ''
  };

  handleExpand = consentSolutionName => {
    this.setState(state => ({
      opened: state.opened === consentSolutionName || consentSolutionName
    }))
  };

  render() {
    const {paymentPeriod, products, classes} = this.props;
    const {currency} = products;
    return (
      <Grid container className={classes.container}>
        <div role="listitem">
          <ProductsSummaryListItem
            label="item"
            qty="#"
            cost={`per ${paymentPeriod}`}
            translation={false}
          />
          <div role="listitem">
            <ProductsSummaryListItem
              label={'summary.consent_solution'}
              cost={convertPrice(products.sum, currency)}
              className={classes.header}
            />
            {products.consent_solutions.map(({name, sum, domains_qty, prices_grouped}) => <div
              role="listitem" key={name}>
              <ProductsSummaryListItem
                expand={true}
                expanded={this.state.opened}
                qty={domains_qty}
                label={name}
                cost={convertPrice(sum, currency)}
                translation={false}
                className={`${classes.consentSolution} ${classes.item}`}
                onExpand={() => {
                  this.handleExpand(name);
                }}
              />

              {this.state.opened === name ? <div>
                {
                  Object.entries(prices_grouped).map(([name, {domains_qty, sum, nodes}]) => domains_qty ? <div
                      role="listitem"
                      key={`${name}-${domains_qty}-${sum}`}
                    >
                      <ProductsSummaryListItem
                        qty={domains_qty}
                        label={`summary.${name}`}
                        cost={convertPrice(sum, currency)}
                        className={`${classes.depth} ${classes.item}`}

                      />
                      {
                        Object.entries(nodes).map(([name, {domains_qty, sum, domains}]) => domains_qty ? <div
                          role="listitem"
                          key={`${name}-${domains_qty}-${sum}`}
                        >
                          <ProductsSummaryListItem
                            qty={domains_qty}
                            label={`summary.${name}`}
                            cost={convertPrice(sum, currency)}
                            className={`${classes.frequency} ${classes.item}`}
                          />
                          {
                            domains.map(item => (
                              <ProductsSummaryListItem
                                label={item}
                                className={`${classes.domain} ${classes.item}`}
                                translation={false}
                                key={`${item}-${domains_qty}`}
                              />)
                            )
                          }
                        </div> : null)
                      }
                    </div> : null
                  )
                }
              </div> : null}
            </div>)}
            <ProductsSummaryListItem
              label="Subtotal"
              cost={convertPrice(products.sum, products.currency)}
              qty={products.domains_qty}
              translation={false}
              className={`${classes.footer}`}
            />

          </div>
        </div>
      </Grid>
    )
  }
}

export default withStyles(styles)(ProductsSummary);
